import { render, staticRenderFns } from "./TaxaOcupacaoCard.vue?vue&type=template&id=6b4191d2&scoped=true"
import script from "./TaxaOcupacaoCard.vue?vue&type=script&lang=js"
export * from "./TaxaOcupacaoCard.vue?vue&type=script&lang=js"
import style0 from "./TaxaOcupacaoCard.vue?vue&type=style&index=0&id=6b4191d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4191d2",
  null
  
)

export default component.exports